<template>
    <v-content>
        <v-toolbar dark flat color="secondary">
                <v-toolbar-title :style="$store.state.textFormatting.headers">
                    Search ASN
                </v-toolbar-title>
                <!--
                <v-menu open-on-hover top offset-x eager class="grow" max-height="400px">
                    <template v-slot:activator="{ on }">
                    <v-btn flat v-on="on" icon outline> <v-icon >list</v-icon></v-btn>
                    </template>
                    <v-list class="grow" min-width="400px" v-for="(key, i) in this.$store.state.allASNInfoForOrg" :key="key">
                        <v-tooltip color="accent" right dark>
                            <template v-slot:activator="{ on }">
                                <v-list-tile @click="updateasn(i)" v-on="on">
                                    <v-list-tile-title>AS {{ i.asn }}</v-list-tile-title>
                                </v-list-tile>
                            </template>
                            <span>AS {{ i.asn }}</span>
                        </v-tooltip>
                    </v-list>
                </v-menu>
                -->
                <v-spacer />
                <v-form ref="form" v-model="valid" lazy-validation>
                    <v-text-field 
                        v-model="input_asn" 
                        label="ASN Input"
                        :rules="asn_rules" 
                        @keyup.enter.prevent.native="validate"
                        :style="$store.state.textFormatting.headers">
                    </v-text-field>
                    <v-text-field class="hidden" v-model="potato" label="not a thing" v-show="false" />
                </v-form>
                
                <v-spacer></v-spacer>
                <info>
                    <template>
                        Mini ASN Baseline
                    </template>
                    <template slot="body">
                        <p> 
                            Input an ASN to get a brief summary of the networks associated with it. 
                            If the ASN is one of either your organisation's ASNs or user ASNs, 
                            this will also display the user designated thresholds for said ASN 
                        </p>
                        <p> 
                            Additional information regarding all ASNs has been collected from Internet Registries.
                        </p>
                        <br />
                        <p> Country is calculated as a percentage where any percentage less than 0.01% will display as 0%  </p>

                    </template>
                    <template slot="action">
                        <v-btn flat color="primary" to="/ASNBaseline" :style="$store.state.textFormatting.main"> ASN Baseline </v-btn>
                    </template>
                </info>
        </v-toolbar>
        <v-card> 
            <v-card-text :style="$store.state.textFormatting.main">
                <v-layout wrap v-if="showInfo">
                    <v-flex >
                        <v-layout justify-center wrap>
                            <v-flex xs12 md3>
                                <h3 display-1> AS {{currentasn}} </h3>
                            </v-flex>
                            <v-spacer />
                            <v-flex xs12 md9>
                                <h3 class="text-xs-right" v-if="!owner_loading">  {{ asn_owner }}</h3>
                                <v-progress-circular v-if="owner_loading" indeterminate color="purple"></v-progress-circular>
                            </v-flex>
                        </v-layout>
                        <v-divider> </v-divider>
                        <v-layout wrap justify-center v-if="input_asn_org">
                            <v-flex xs10>
                                <h4 class='text-xs-center'> Organisation defined ASN alerting thresholds </h4>
                            </v-flex>
                            <v-flex xs11>
                                <v-layout justify-center>
                                    <v-flex xs12 md6 xl4>
                                        <h4> Hijack = {{input_asn_org.h}} </h4>
                                    </v-flex>
                                    <v-flex xs12 md6 xl4>
                                        <h4> Impact = {{input_asn_org.i}} </h4>
                                    </v-flex>
                                    <v-flex xs12 md6 xl4>
                                        <h4> Validation = {{input_asn_org.v}} </h4>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap justify-center v-if="input_asn_user">
                            <v-flex xs10>
                                <h4 class='text-xs-center'> User defined ASN alerting thresholds </h4>
                            </v-flex>
                            <v-flex xs11>
                                <v-layout justify-center>
                                    <v-flex xs12 md6 xl4>
                                        <h4> Hijack = {{input_asn_user.h}} </h4>
                                    </v-flex>
                                    <v-flex xs12 md6 xl4>
                                        <h4> Impact = {{input_asn_user.i}} </h4>
                                    </v-flex>
                                    <v-flex xs12 md6 xl4>
                                        <h4> Validation = {{input_asn_user.v}} </h4>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-flex >
                    <v-progress-circular v-if="loading" indeterminate color="secondary" ></v-progress-circular>
                </v-flex>
                <v-data-table  v-if="showTable" :headers="headersPrefixLocation" :items="ASNEnirchData">
                    <template slot="headerCell" slot-scope="props">
                        <v-tooltip top eager>
                        <span slot="activator" :style="$store.state.textFormatting.main">
                            {{ props.header.text }}
                        </span>
                        <span :style="$store.state.textFormatting.main">
                            {{ props.header.ad_text }}
                        </span>
                        </v-tooltip>
                    </template>
                    <template slot="items" slot-scope="props">
                        <tr>
                            <td class="text-xl-left" :style="$store.state.textFormatting.main"> {{ props.item.prefix }}</td>
                            <td class="text-xl-center" :style="$store.state.textFormatting.main"> {{ props.item.country }}</td>
                        </tr>
                    </template>
                </v-data-table>
                <v-layout justify-center align-center v-if="info && !loading">
                    <v-flex xs9 v-if="info">
                        <h4 display-1 class="text-xs-center" :style="$store.state.textFormatting.main"> {{message}}</h4>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-content>
</template>

<script>
import { API, graphqlOperation} from 'aws-amplify'
import { countryNamesRev } from '../operational/countrynames.js'
import { countryNames } from '../operational/countrynames.js'
import info from './infopopout.vue'

export default {
    name: 'asncountrysearch',
    components: {
        info
    },
        data () {
        return {
            valid: true,
            message: 'Find geo information on ASNs and prefixes.',
            info: true,
            asn_owner: "",
            countrysearch: false,
            asnsearch: false,
            countryNamesList: countryNamesRev,
            currentcountry: '',
            countryinfo: [],
            bottomNav: '',
            data: [],
            rowsPerPageItems: [5, 10],
            pagination: {
                rowsPerPage: 5
                },
            id: 0,
            currentasn: null,
            alertscurrent: 0,
            ASNdata: [],
            ASNEnrichData: [],
            countryName: '',
            headersPrefixLocation: [
                { text: 'Prefix', value:'prefix', sortable: false, align:'left', ad_text: ''},
                
                { text: 'Country', value:'country', sortable: false, align:'centre', ad_text: ''}
                ],
            prefixnum: '',
            asselected: false,
            showprefixassociations: false,
            owner_loading: false,
            ASNStat: [],
            loading: false,
            ASNEnirchData: [],
            selectedASNData: [],
            showInfo: false,
            showTable: false,
            asn_rules: [ v => /(^\d+$)/.test(v) || 'ASN must be non-negative integer'],
            input_asn: null,
            input_asn_org: false,
            input_asn_user: false,
            potato: false
        }
    },
    methods: {
        validate: async function () {
            console.log("ASDASDASD")
            if (this.$refs.form.validate()) {
                this.input_asn_org = false
                this.input_asn_user = false
                this.ASNEnirchData = []
                console.log(this.$store.state.allASNInfoForOrg)
                for ( var i = 0 ; i < this.$store.state.allASNInfoForOrg.length ; i++ ) {
                    console.log(this.$store.state.allASNInfoForOrg[i].asn)
                    if (this.input_asn == this.$store.state.allASNInfoForOrg[i].asn) {
                        this.input_asn_org = {
                            h: this.$store.state.allASNInfoForOrg[i].H,
                            i: this.$store.state.allASNInfoForOrg[i].I,
                            v: this.$store.state.allASNInfoForOrg[i].V,
                        }
                        this.alertscurrent = this.$store.state.allASNInfoForOrg[i].count
                    }
                }

                for ( var i = 0 ; i < this.$store.state.allASNInfoForUser.length ; i++ ) {
                    if (this.input_asn == this.$store.state.allASNInfoForUser[i].asn) {
                        this.input_asn_user = {
                            h: this.$store.state.allASNInfoForUser[i].H,
                            i: this.$store.state.allASNInfoForUser[i].I,
                            v: this.$store.state.allASNInfoForUser[i].V,
                        }
                        this.alertscurrent = this.$store.state.allASNInfoForUser[i].count
                    }
                }
                this.updateasn(this.input_asn)
                this.showInfo = true;
            }
        },
        updateasn: function (i) { //This updates when the user clicks on it 

            this.currentasn = i
            this.asselected = true


            //this.getASEnrichD(i);
            //this.prefixlist(i);
            this.getASD(i);
            this.getASNOwner();

        },
        getASNOwner: async function () {
            try {
                this.owner_loading = true;
                var qry = `query getASNOwner { getASNOwner ( asn: "` + this.currentasn + `" ) {
                        organisation
                    }
                }`;
                console.log(qry)
                const res = await API.graphql(graphqlOperation(qry));
                var ownData = res.data.getASNOwner;
                console.log(ownData);
                if (ownData) {
                    if (ownData.length > 0) {
                        console.log("owner: ")
                        console.log(ownData[0].organisation)
                        if (ownData[0].organisation) {
                            this.asn_owner = ownData[0].organisation;
                            this.owner_loading = false;
                        } else {
                            this.asn_owner = "Unknown Owner"
                            this.owner_loading = false;
                        }
                    } else {
                        this.asn_owner = "Unknown Owner"
                        this.owner_loading = false;
                    }
                } else {
                    this.asn_owner = "Unknown Owner"
                    this.owner_loading = false;
                }
            } catch (err) {
                console.log(err)
                this.asn_owner = "Unknown Owner"
                this.owner_loading = false;
            }
        },
        getASD: async function (selectedASNInfo) {
            this.loading = true;
            try {
                var getASNEnrichmentData = `query getASNEnrich {
                                                getASNEnrich(asn: "`+selectedASNInfo+`", page_offset:0, page_rows:1000) {
                                                    asn
                                                    prefix
                                                    country
                                                    
                                                }
                                            }`
               

                const ASNEnrichmentData = await API.graphql(graphqlOperation(getASNEnrichmentData));
                var ASNEnrichmentdataUnwraped = ASNEnrichmentData.data.getASNEnrich
                console.log("This is the length")
                console.log(ASNEnrichmentdataUnwraped.length)

                if (ASNEnrichmentdataUnwraped.length > 0) {
                    console.log("length greater than 0")
                    for(var count=0; count<ASNEnrichmentdataUnwraped.length; count=count+1){
                    if (ASNEnrichmentdataUnwraped[count].country == null) {
                        ASNEnrichmentdataUnwraped[count].country = "Unknown"
                    } else {
                        ASNEnrichmentdataUnwraped[count].country = this.sortPrefixCountry(JSON.parse(ASNEnrichmentdataUnwraped[count].country))
                        console.log(ASNEnrichmentdataUnwraped[count].country)
                        }
                    }

                    this.ASNEnirchData = ASNEnrichmentdataUnwraped;

                    this.loading=false;
                    this.showInfo = true;
                    this.showTable = true;
                    this.message='';
                } else if (ASNEnrichmentdataUnwraped.length == 0){
                    this.ASNEnirchData = false;
                    this.loading = false;
                    this.message = "We have no geo data for this ASN"
                    this.showInfo = true;
                    this.showTable = false;
                }

                

            } catch(err) {
                this.loading = false;
                this.message = "We have no geo data for this ASN"
                console.log(err)
                //This needs to be chnaged to fill the userbox with 'No data' or somthing
            }
            this.loading = false;
        },
        sortPrefixCountry: function (countryJSON) {
                
            var keys = Object.keys(countryJSON)
            var countryString = ""
            var country_keys_list = []
            for (var j = 0; j < keys.length ; j++) {
                country_keys_list.push({
                    'code': keys[j],
                    'prop': countryJSON[keys[j]]
                })
            }

            country_keys_list.sort(function(a, b) {
                var keyA = a.prop,
                    keyB = b.prop;
                // Compare the 2 dates
                if (keyA < keyB) return 1;
                if (keyA > keyB) return -1;
                return 0;
            });
            for (var i =0; i< country_keys_list.length; i = i+1) {
                countryString = countryString + countryNames[country_keys_list[i].code] + ": " + country_keys_list[i].prop + "%"
                if (i != keys.length - 1 && keys.length > 1) {
                    countryString= countryString + ", "
                }
            }
            return countryString;
            
        }
    }
}
</script>

